import React, {Component} from 'react';
import styled from 'styled-components';
import PropTypes from "prop-types";
import Localizer from "../helpers/Localizer";

// import {SharedMapContextConsumer} from "../SharedMapContext";

const BoxWrapper = styled.div`
    font-family: Open\\ Sans,sans-serif;
    font-weight: 300;
    font-size: 13px;
    text-align: left;
    cursor: default;
    position: absolute;
    padding: 0;
    width: 320px;
    height: 260px;
    overflow: auto;
    transform: translate(-50%, -310px);
    z-index:2;
    background-color: #fff; // rgba(0, 0, 0, 0.2);
    border-radius: 2px;
    box-shadow: rgba(0,0,0,0.4) -1px 1px 5px 1px;
    
    background: url('${props => ('https://www.system.huishurenibiza.nl/uploads/photos/cache/index_thumb/uploads/photos/' + props.item.photo)}') no-repeat center center;
    background-size: auto 100%;
    
    @media (max-width: 991px) {
    max-width: 320px;
    max-height: 260px;
    // position: fixed;
    // top: 139px;
    // margin: 0 20px;
    // left: -21px;
    // z-index: 3;
    }
`;

const ContentWrapper = styled.div`
    background-color: rgba(255,255,255,${props => (props.type === 'store' ? '1.0' : '0.8')});
    width: 100%;
    bottom: 0;
    position: absolute;
    padding: 8px 8px 23px 8px;
    color: #2d2c2a;
    ${props => (props.type === 'store' ? 'height: 100%;' : '')}
    .title {
        font-family: Montserrat,sans-serif;
        font-size: 14px;
        margin-bottom: 6px;
        display: inline-block;
    }
    
    ul.list {
        list-style: none;
        padding: 0;
        margin: 0;
    }
`;

const CloseButton = styled.button`
    text-shadow: 0px 0px 10px white;
    background: none;
    display: block;
    border: 0px;
    margin: 0px;
    padding: 0px;
    position: absolute;
    cursor: pointer;
    user-select: none;
    top: 0px;
    right: 0px;
    width: 37px;
    height: 33px;
    &:focus {outline:0;}
    
    i {
        border: 1px solid white;
        background: #fff;
        padding: 1px 3px;
        box-shadow: rgba(0,0,0,0.5) 0px 1px 4px -1px;
    }
    
`;

const LinkButton = styled.a`
    height: 40px;
    border-radius: 5px;
    background-color: #d01f49;
    color: #fff;
    border: 1px solid #d01f49;
    padding: 4px 10px;
    font-family: Montserrat,sans-serif;
    font-weight: 200;
    white-space: nowrap;
    position: fixed;
    line-height: 32px;
    font-size: 14px;
    transform: translate(-50%, -71px);
    z-index: 3;
    box-shadow: rgba(0,0,0,0.9) 0px 1px 2px -1px;
    &:hover {
        color: #fff;
        text-decoration: none;
    }
    
    &:focus {
    color: #fff;
    text-decoration: inherit;
    }

`;

class Tooltip extends Component {

    static propTypes = {
        visible: PropTypes.bool.isRequired,
        item: PropTypes.object.isRequired,
        onClose: PropTypes.func.isRequired,
    };

    static strip(html) {
        let tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
    }

    render() {

        const locale = document.getElementsByTagName('html')[0].getAttribute('lang');

        let url = this.props.item.url;
        if (this.props.price !== undefined) {
            url += '?house[from]='+ this.props.price.date_from+ '&house[to]='+ this.props.price.date_to;
        }

        return (
            this.props.visible &&
            <div>
                <BoxWrapper {...this.props.item ? {item: this.props.item} : {}}>
                    <ContentWrapper {...this.props.type ? {type: this.props.type} : {}}>
                        {/* HOUSE */}
                        {this.props.type === 'house' &&
                        <div>
                            <a href={url} target="_blank" rel="noopener noreferrer"><span
                                className="title">{this.props.item.name}</span></a>
                            <ul className="list">
                                <li>
                                    <strong>{Localizer.translate("persons", locale)}</strong>: {this.props.item.base_guests}
                                </li>
                                <li>
                                    <strong>{Localizer.translate("price", locale)}</strong>: {Localizer.roundEuro(this.props.item.min_price)} {Localizer.translate("to", locale)} {Localizer.roundEuro(this.props.item.max_price)}
                                </li>
                            </ul>
                        </div>
                        }

                        {/* STORE */}
                        {this.props.type === 'store' &&
                        <div>
                            <a href={this.props.item.url} target="_blank" rel="noopener noreferrer"><span
                                className="title"><i className="fa fa-shopping-cart"/> {this.props.item.name}</span></a>
                            <ul className="list">
                                <div dangerouslySetInnerHTML={{__html: this.props.item.description}}/>
                            </ul>
                        </div>
                        }

                        {/* CLUB or PLACE */}
                        {(this.props.type === 'club' || this.props.type === 'place' || this.props.type === 'market') &&
                        <div>
                            <a href={this.props.item.url} target="_blank" rel="noopener noreferrer"><span
                                className="title">{this.props.item.name}</span></a>
                            <ul className="list">
                                <div>{Tooltip.strip(this.props.item.description).substring(0, 90) + '...'}</div>
                            </ul>
                        </div>
                        }

                        {/* BEACH CLUB or RESTAURANT OR BEACH */}
                        {(this.props.type === 'beach_club' || this.props.type === 'restaurant' || this.props.type === 'beach') &&
                        <div>
                            <a href={this.props.item.url} target="_blank" rel="noopener noreferrer"><span
                                className="title">{this.props.item.name}</span></a>
                            <ul className="list">
                                <div>{Tooltip.strip(this.props.item.description).substring(0, 90) + '...'}</div>
                            </ul>
                        </div>
                        }


                    </ContentWrapper>
                    <CloseButton onClick={this.props.onClose}>
                        <i className="closeTooltip fa fa-times"/>
                    </CloseButton>
                </BoxWrapper>


                <LinkButton href={url} target="_blank"
                            rel="noopener noreferrer">{
                    locale === 'de'
                        ? (Localizer.translate(this.props.type, locale) + ' ' + Localizer.translate("show", locale))
                        : (Localizer.translate("show", locale) + ' ' + Localizer.translate(this.props.type, locale))}</LinkButton>
            </div>
        );
    }
}

export default Tooltip;
